var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar-nav-icon',{staticClass:"ml-3 mr-5",style:({ width: (_vm.width + "px") }),attrs:{"to":"/home"}},[_c('v-img',{attrs:{"src":_vm.view.smallLogo,"aspect-ratio":16 / 9,"contain":"","max-height":"32px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }